export default "__VITE_ASSET__BB9u6mh8__"